import React from 'react';

interface MagazinePageHeaderProps {
  title: string;
  description: string;
  action?: React.ReactNode;
}

const MagazinePageHeader: React.FC<MagazinePageHeaderProps> = ({
  title,
  description,
  action,
}) => (
  <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
      <p className="mt-1 text-sm text-gray-500">{description}</p>
    </div>
    {action}
  </div>
);

export default MagazinePageHeader;
